<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@propertyReportDialog-propertyReport">Property Report</h2>
		<button mat-icon-button>
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="property-report-close-button"
				>close</mat-icon
			>
		</button>
	</div>
	<mat-dialog-content class="drawer-dialog-content">
		<h3 class="drawer-dialog-content-header" i18n="@@propertyReportDialog-devices">Devices</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="devices-typeahead"
				[allDropdownOptions]="devices"
				[filterOnField]="'serialNumber'"
				[placeholderText]="this.deviceMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="deviceIds"
				[initiallySelectedIdField]="'serialNumber'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
				(searchInputChanged)="onSearchInput('device', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<div>
			<mat-divider></mat-divider>
			<h3 class="drawer-dialog-content-header" i18n="@@propertyReportDialog-deviceStatus">Status</h3>
			<app-loading-indicator
				[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
				diameter="30"
			>
				<app-multi-select-typeahead
					data-automation-id="status-typeahead"
					[allDropdownOptions]="deviceStatuses"
					[filterOnField]="'deviceStatus'"
					[placeholderText]="this.deviceStatusMultiSelectorSearchPlaceHolder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-nav-work'"
					[initiallySelectedItemIds]="deviceStatusIds"
					[initiallySelectedIdField]="'deviceStatus'"
					[minCharactersForSearch]="3"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceStatus', $event)"
					(searchInputChanged)="onSearchInput('deviceStatus', $event)"
				>
				</app-multi-select-typeahead>
			</app-loading-indicator>
		</div>

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@propertyReportDialog-propertyNames">Property Name</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="property-names-typeahead"
				[allDropdownOptions]="propertyNames"
				[filterOnField]="'propertyName'"
				[placeholderText]="this.propertyNamesMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-lock'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="propertyNameIds"
				[initiallySelectedIdField]="'propertyName'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('property', $event)"
				(searchInputChanged)="onSearchInput('property', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@propertyReportDialog-postalCodes">Postal Code</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="postal-code-typeahead"
				[allDropdownOptions]="postalCodes"
				[filterOnField]="'postalCode'"
				[placeholderText]="this.postalCodesMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="postalCodeIds"
				[initiallySelectedIdField]="'postalCode'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('postalCode', $event)"
				(searchInputChanged)="onSearchInput('postalCode', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<!--     Commented out because not in AC-->

		<!-- <h3 class="drawer-dialog-content-header" i18n="@@propertyReportDialog-removalReuested">Removal Requested</h3>
        <app-loading-indicator [keys]="[apiLoadingKeys.getPropertyReportFilterOptions, apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]" diameter="30">
            <app-multi-select-typeahead [allDropdownOptions]="removalRequested" [filterOnField]="'removalRequested'"
                [placeholderText]="this.removalRequestsMultiSelectorSearchPlaceHolder"
                [showSelectionsInInputField]="false" [showSelectedItemSubOption]="false"
                [selectedItemIconName]="'sl-add-user'" [showSelectedItemMessage]="false"
                [initiallySelectedItemIds]="removalRequests" [initiallySelectedIdField]="'removalRequested'"
                (selectedOptionsChangedEvent)="onSelecteRemovalRequestChangedEvent($event)">
            </app-multi-select-typeahead>
        </app-loading-indicator> -->

		@if (isCareCompany) {
			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientFirstName">Client First Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="first-name-typeahead"
						[allDropdownOptions]="firstNames"
						[filterOnField]="'firstName'"
						[placeholderText]="this.firstNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="firstName"
						[initiallySelectedIdField]="'firstName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('firstName', $event)"
						(searchInputChanged)="onSearchInput('firstName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientLastName">Client Last Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="last-name-typeahead"
						[allDropdownOptions]="lastNames"
						[filterOnField]="'lastName'"
						[placeholderText]="this.lastNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="lastName"
						[initiallySelectedIdField]="'lastName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('lastName', $event)"
						(searchInputChanged)="onSearchInput('lastName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientIdn">Client IDN</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="client-idn-typeahead"
						[allDropdownOptions]="clientIdns"
						[filterOnField]="'idn'"
						[placeholderText]="this.clientIdnMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="clientIdn"
						[initiallySelectedIdField]="'idn'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('clientIdn', $event)"
						(searchInputChanged)="onSearchInput('clientIdn', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				(click)="onCloseDialog()"
				data-automation-id="property-report-close-button"
				i18n="@@propertyReportDialog-closeWindow"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				data-automation-id="generate-property-report-button"
				(click)="onGenerateReport()"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
